import { InformationWrapper } from "./Information.styles";

const Information = ({ children }) => {
  return <InformationWrapper>{children}</InformationWrapper>;
};

export default Information;
